<template>
  <div class="menu-item ri-title" v-on:click="onClick" :class="{ disabled, selected, small }"
       role="menuitem" tabindex="0" @keyup.enter="onClick" :aria-label="title">
    <div class="icon-container">
      <icon v-if="iconName" :icon-name="iconName" fill size="24px" :color="iconColor" :optical-size="24"/>
    </div>
    <span class="menu-item-title">
      {{ title }}
      <tag v-if="showNewBadge" :text="badgeText" :background-color="badgeBgColor" :text-color="badgeTextColor" />
      <img v-if="showBetaBadge" :src="require('@/assets/icons/beta-menu.svg')" />
      <slot></slot>
    </span>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'MenuItem',
  components: {
    Tag: BaseUI.Tag,
    Icon: BaseUI.Icon,
  },
  data() {
    return {
      iconColor: BaseUI.Colors.riseupDarkGreen,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    onClick: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconName: {
      type: String,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
      default: false,
    },
    showNewBadge: {
      type: Boolean,
    },
    showBetaBadge: {
      type: Boolean,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    badgeText: {
      type: String,
      default: 'חדש!',
    },
    badgeBgColor: {
      type: String,
      default: BaseUI.Colors.riseupGreen,
    },
    badgeTextColor: {
      type: String,
      default: BaseUI.Colors.riseupWhite,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/spacings';
@import '~@riseupil/base-ui/src/scss/border-radius';
@import '~@riseupil/base-ui/src/scss/typography';

.menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: $ri-spacing-ml;
  cursor: pointer;
  border-radius: $card-border-radius;

  &.small {
    font-size: $ri-font-size-18;
    margin-bottom: $ri-spacing-s;
  }

  &.selected {
    background: $riseup_beige;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .icon-container {
    width: 24px;
    height: 24px;
    border-radius: $ri-border-radius-medium;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: $ri-spacing-sm;
    margin-right: $ri-spacing-xs;
  }

  .menu-item-title {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 8px;

    ::v-deep .tag {
      padding: 2px 6px;
    }
  }
}
</style>
